type Education = {
  degree: string;
  institution: string;
  years: string;
  cgpa: string;
};

type Language = {
  language: string;
};

type EducationSectionProps = {
  education: Education[];
  languages: Language[];
};

const EducationSection = ({ education, languages }: EducationSectionProps) => (
  <section
    className="education-section section-shell"
    aria-labelledby="education-title"
  >
    <div className="education-section__intro" data-reveal>
      <span className="eyebrow">Education / languages</span>
      <h2 id="education-title">The foundation behind the practice.</h2>
      <p>
        Formal training in information systems and computer science, supported
        by day-to-day communication in English and Malay.
      </p>
    </div>

    <div className="education-list">
      {education.map((item, index) => (
        <article key={item.degree} data-reveal>
          <span>{String(index + 1).padStart(2, "0")}</span>
          <div>
            <p>{item.years}</p>
            <h3>{item.degree}</h3>
            <h4>{item.institution}</h4>
            <small>CGPA {item.cgpa}</small>
          </div>
        </article>
      ))}
    </div>

    <div className="language-list" data-reveal>
      <span>Languages</span>
      <ul>
        {languages.map((language) => (
          <li key={language.language}>{language.language}</li>
        ))}
      </ul>
    </div>
  </section>
);

export default EducationSection;
